<template>
  <LaowaiSurvivalGame/>
</template>

<script>
import LaowaiSurvivalGame from '@/components/LaowaiSurvivalGame.vue'

export default {
  name: 'LaowaiSurvivalView',
  components: {
    LaowaiSurvivalGame
  }
}
</script>
